import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'ui-radio',
    template: require('./radio.component.html')
})
export class RadioComponent implements OnInit {
    
    private _opciones: string[];
    @Input() set opciones(o: string[]) {
        this._opciones = (o || []);
    }
    get opciones() { return this._opciones }
    
    private _value: string;
    @Input() set value(v) {
        this._value = (v || '');
    }
    get value() { return this._value }
    
    constructor() { }

    ngOnInit() { }
    
    
} 


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./app/_extra/ui/radio.component.ts